import { BaseAudioRecordingAppEventOperation } from "./BaseAudioRecordingAppEventOperation";
import { AudioRecordingAppEventOperationKind } from "@/store/sync/operations/types";

export class MarkResumedLocalAudioRecordingOperation extends BaseAudioRecordingAppEventOperation {
  get operationKind(): AudioRecordingAppEventOperationKind {
    return "MARK_RESUMED_LOCAL_AUDIO_RECORDING";
  }

  // Resume doesn't change recording_status - it's still IN_PROGRESS
  // The event is tracked for observability purposes
}
